export default __webpack_public_path__ + "static/Organic_Polymer-4d2e54371c46e83a8b85782250350d84.png";